import React from 'react';

import { useTranslation } from 'react-i18next';
import { capitalize } from '@helpers/string.helpers';
import {GenericDropdown} from '@web/ui/components/group/customsignup/Dropdown';

interface FontSelectorProps {
    font: string;
    setFont: (font: string) => void;
    options: any[];
}

export const OPTION_FONT_TO_DISPLAYNAME = {
    'Pacifico':'Pacifico',
    'CedarvilleCursive':'Cedarvill Cursive',
    'DancingScript': 'DancingScript',
    'GreatVibes':'GreatVibes',
    'Sacremento':'Sacramento',
    'Sacramento':'Sacramento',
}

export const OPTION_FONT_TO_CSS_CLASS = {
    'Pacifico':'font-pacifico',
    'CedarvilleCursive':'font-cedarville',
    'DancingScript': 'font-dancing',
    'GreatVibes':'font-greatvibes',
    'Sacremento':'font-sacramento',
    'Sacramento':'font-sacramento',
}

const FontSelector: React.FC<FontSelectorProps> = ({ font, setFont, options }) => {
    const { t } = useTranslation();

    console.log('//Font Selector options', options);

    return (
        <>
            <h4>
                <label htmlFor="font-selector">{capitalize(t('common:font', 'font')) + ':'}</label>
            </h4>


             <GenericDropdown
               handleCustomChange={(option:string)=> setFont(option)}
               name={font}
               options={options}
               value={font}
            /> 
        </>
    );
};

export default FontSelector;
